import DeleteRenderer from "./deleteCellRender";
import EditRenderer from "./editCellRender";
import {
  dateTimeFormatter,
  typeFormatter,
  valueFormatter,
  soakDurationFormatter
} from "../../utils/tableDataFormatter";

/**
 * User Added CIP Table Column Configuration
 * @param {function} t - Translation function
 * @param {string} temperature - Temperature unit (e.g., 'C', 'F')
 * @param {string} mass - Mass unit (e.g., 'kg', 'lb')
 * @returns {Array} Column definitions for ag-Grid
 */
export const USER_ADDED_TABLE_COLUMNS = (t, temperature, mass) => [
  {
    headerName: t("HistoricCipTableStrings.start_date"),
    field: "start_date",
    editable: false,
    flex: 1,
    valueFormatter: dateTimeFormatter,
    sortable: true,
    headerClass: "custom-Header-cip-user-table",
    minWidth: 200,
  },
  {
    headerName: t("HistoricCipTableStrings.end_date"),
    field: "end_date",
    editable: false,
    flex: 1,
    valueFormatter: dateTimeFormatter,
    sortable: true,
    headerClass: "custom-Header-cip-user-table",
    minWidth: 200,
  },
  {
    headerName: t("HistoricCipTableStrings.type"),
    field: "type",
    editable: false,
    valueFormatter: (params) => typeFormatter(params, t),
    flex: 1,
    sortable: true,
    headerClass: "custom-Header-cip-user-table",
    minWidth: 100,
  },
  {
    headerName: t("HistoricCipTableStrings.acid_soak_duration"),
    field: "acid_soak_duration",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => soakDurationFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 300,
  },
  {
    headerName: t("HistoricCipTableStrings.acid_used").replace("<unit>", mass),
    field: "acid_used",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => valueFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 250,
  },
  {
    headerName: t("HistoricCipTableStrings.acid_ph"),
    field: "acid_ph",
    editable: false,
    sortable: true,
    valueFormatter: (params) => valueFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 150,
  },
  {
    headerName: t("HistoricCipTableStrings.acid_temp").replace(
      "<unit>",
      `\u00B0${temperature}`
    ),
    field: "acid_temp",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => valueFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 275,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_soak_duration"),
    field: "alkali_soak_duration",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => soakDurationFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 300,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_used").replace(
      "<unit>",
      mass
    ),
    field: "alkali_used",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => valueFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 250,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_ph"),
    field: "alkali_ph",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => valueFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 175,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_temp").replace(
      "<unit>",
      `\u00B0${temperature}`
    ),
    field: "alkali_temp",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => valueFormatter(params, "type"),
    headerClass: "custom-Header-cip-user-table",
    minWidth: 275,
  },
  {
    headerName: t("HistoricCipTableStrings.add_info"),
    field: "add_info",
    hide: true,
    editable: false,
    flex: 1,
    sortable: true,
    headerClass: "custom-Header-cip-user-table",
    minWidth: 150,
  },
  {
    colId: "delete",
    lockPinned: true,
    pinned: "right",
    width: 50,
    headerName: t("ValueStrings.delete"),
    cellRenderer: DeleteRenderer,
  },
  {
    colId: "edit",
    lockPinned: true,
    pinned: "right",
    width: 50,
    headerName: t("ValueStrings.edit"),
    cellRenderer: EditRenderer,
  },
];

//  Adding strings for future purpose

// "acidPh": "Acid CIP pH",
// "acidTemperature": "Acid CIP Temperature (<unit>)",
// "acidDuration": "Acid CIP Soak Duration (hrs)",
// "acidUsed": "Acid used per CIP (<unit>)",
// "alkaliPh": "Alkali CIP pH",
// "alkaliTemperature": "Alkali CIP Temperature (<unit>)",
// "alkaliDuration": "Alkali CIP Soak Duration (hrs)",
// "alkaliUsed": "Alkali used per CIP (<unit>)",
// "solutionPh": "CIP Solution pH",
// "solutionTemperature": "CIP Solution Temperature (<unit>)",
// "solutionDuration": "CIP Solution Soak Duration (hrs)",
// "solutionUsed": "CIP Solution used per CIP (<unit>)",
// "addInfo": "Additional Information"
